import { FunctionComponent, useState } from "react";
import { StyledIcon, StyledSearch, StyledWrapper } from "./search.styles";
import { faSearch } from "components/icon-library";

interface TableSearchProps {
  keyword: string;
  hint?: string;
  onChange: (keyword: string) => void;
}

const TableSearch: FunctionComponent<TableSearchProps> = ({
  keyword,
  hint,
  onChange,
}) => {
  const [hover, toggleHover] = useState(false);
  const [focus, toggleFocus] = useState(false);

  const handleKeyup = (e: any) => {
    if (e.key === "Escape") {
      onChange("");
    }
  };

  return (
    <StyledWrapper>
      <StyledSearch
        $focus={focus}
        $hover={hover}
        type="text"
        placeholder={hint || "Hae taulukosta..."}
        value={keyword}
        onChange={(e) => onChange(e.target.value)}
        onKeyUp={handleKeyup}
        onMouseEnter={() => toggleHover(true)}
        onMouseLeave={() => toggleHover(false)}
        onFocus={() => toggleFocus(true)}
        onBlur={() => toggleFocus(false)}
      />
      <StyledIcon icon={faSearch} />
    </StyledWrapper>
  );
};

export default TableSearch;
